import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Avatar from "@mui/material/Avatar";
import CardContent from "@mui/material/CardContent";
import { Accordion, Typography, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionSummaryReverse } from "../../components/Accordion";

const style = (feature) => {
  let type = feature.properties.type;
  const defaultStyle = {
    color: "#640000",
    weight: 2,
    fillOpacity: 0.3,
    fillColor: "#640000",
  };
  switch (type) {
    case "Tornado warning":
      return { ...defaultStyle, fillColor: "#8b0000" };
    case "Severe thunderstorm warning":
      return { ...defaultStyle, fillColor: "#FFD27F" };
    case "Flash flood warning":
      return { ...defaultStyle, fillColor: "#C57F7F" };
    default:
      return { ...defaultStyle, fillColor: "#000000" };
  }
};

const PopupTemplate = (props) => {
  const feature = props.feature;

  return <WeatherWarning feature={feature} {...props} />;
};

const WeatherWarning = (props) => {
  const feature = props.feature;
  const properties = feature.properties;

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardHeader
        avatar={
          <Avatar
            alt="Weather warning"
            src={
              process.env.PUBLIC_URL +
              "/mapicons/WeatherWarning/Weather_Warning_v16.png"
            }
            sx={{ width: 21, height: 21 }}
            aria-label="Weatherwarning"
          ></Avatar>
        }
        title={<font className="layer-title"> Weather warning </font>}
        className={"styledtablerow"}
        sx={{ pb: 0, paddingTop: 1, paddingLeft: 1 }}
      />
      <CardContent
        sx={{
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          overflow: "auto",
        }}
      >
        <Table size="small">
          <TableRow>
            <TableCell className={"layertablecellLeft"}>
              {properties.headline}
            </TableCell>
          </TableRow>
          <TableRow className={"styledtablerow"}>
            <TableCell className={"layertablecellLeft"}>
              {properties.summary}
            </TableCell>
          </TableRow>
          <div>
            <Accordion>
              <AccordionSummaryReverse
                expandIcon={<ExpandMoreIcon />}
                aria-controls="popup-description"
                id="header"
                className="controls-header"
                sx={{ mt: 0 }}
              >
                <Typography variant="body3">
                  {" "}
                  Click here for more details
                </Typography>
              </AccordionSummaryReverse>
              <AccordionDetails sx={{ height: 150, overflow: "auto" }}>
                <Table size="small">
                  {properties.sections?.map((section, index) => {
                    if (section.heading !== null && section.heading !== "") {
                      return (
                        <TableRow key={index}>
                          <TableCell className={"layertablecellLeft"}>
                            {section.heading}
                          </TableCell>
                          <TableCell className={"layertablecellRight"}>
                            {section.description}
                          </TableCell>
                        </TableRow>
                      );
                    }
                    if (
                      (section.heading === null || section.heading === "") &&
                      section.description !== null &&
                      section.description !== ""
                    ) {
                      return (
                        <TableRow key={index}>
                          <TableCell
                            colSpan={2}
                            className={"layertablecellRight"}
                          >
                            {section.description}
                          </TableCell>
                        </TableRow>
                      );
                    }
                    return null;
                  })}
                </Table>
              </AccordionDetails>
            </Accordion>
          </div>
        </Table>
      </CardContent>
    </Card>
  );
};

const LegendTemplate = (props) => {
  const url =
    process.env.PUBLIC_URL + "/mapicons/WeatherWarning/WeatherWarning.png";

  return (
    <Box sx={{ display: "flex", height: "40px" }}>
      <Box sx={{ ml: 8, display: "flex" }}>
        <Box
          sx={{
            backgroundImage: `url(${url})`,
            backgroundSize: "contain",
            width: "250px",
            backgroundRepeat: "no-repeat",
          }}
        ></Box>
      </Box>
    </Box>
  );
};

const module = {
  name: "Weather Warnings",
  endpoint: "/weatherMap.json",
  showOnMap: true,
  polygonLayer: true,
  PopupTemplate: PopupTemplate,
  updateDelay: 180,
  mapLayerIcon:
    process.env.PUBLIC_URL + "/mapicons/WeatherWarning/Weather_Warning_v16.png",
  LegendTemplate: LegendTemplate,
  style: style,
  maxZoom: 4,
  zIndex: 606,
};

export default module;
